import { Component } from "react";
import API, { URL_PATH } from "../../services/API";
import redux from "../../common/Redux";
import routes from "../../routes/URL";
import {
  Button,
  TextField,
  CardContent,
  CardHeader,
  Box,
  Container
} from "@mui/material";
import Toast from "../../components/Toast";
import Header from "../../components/Header";
import { root_url } from "../../services/API";

class AddSupplierScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toast: {
        open: false,
        message: "",
        severity: "success"
      }
    };
  }

  create = async () => {
    const formdata = new FormData(document.getElementById("supplierForm"));
    formdata.append("hotel_id", this.props.selectedHotelId?.id); // if needed

    console.log([...formdata.entries()]); // Debug log

    const { status, message } = await API(
      this,
      "post",
      `${root_url}/api/hotelowner/inventory/supplier/store`, // Use full endpoint or set in URL_PATH if available
      formdata
    );

    this.setState({
      toast: {
        open: true,
        message: message,
        severity: status === "success" ? "success" : "error"
      }
    });

    if (status === "success") {
      setTimeout(() => {
        this.props.history.push(routes.admin.supplier.list); // update to actual supplier list route
      }, 2000);
    }
  };

  render() {
    return (
      <Container maxWidth="lg" className="py-5">
        <Box
          sx={{
            borderRadius: "10px",
            overflow: "hidden",
            bgcolor: "transparent",
            border: "1px solid #FFC857",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
          }}
        >
          <CardHeader title={<Header title="Add Supplier" />} sx={{ pb: 2 }} />
          <CardContent>
            <form
              id="supplierForm"
              onSubmit={(e) => {
                e.preventDefault();
                this.create();
              }}
            >
              <Box mb={3}>
                <TextField
                  fullWidth
                  id="supplier_name"
                  name="supplier_name"
                  label="Supplier Name"
                  placeholder="Enter Supplier Name"
                  variant="outlined"
                  required
                />
              </Box>

              <Box mb={3}>
                <TextField
                  fullWidth
                  id="phone"
                  name="phone"
                  label="Phone"
                  placeholder="Enter Phone Number"
                  variant="outlined"
                  required
                />
              </Box>

              <Box mb={3}>
                <TextField
                  fullWidth
                  id="email"
                  name="email"
                  label="Email"
                  placeholder="Enter Email"
                  variant="outlined"
                  required
                  type="email"
                />
              </Box>

              <Box mb={3}>
                <TextField
                  fullWidth
                  id="contact_person"
                  name="contact_person"
                  label="Contact Person"
                  placeholder="Enter Contact Person Name"
                  variant="outlined"
                  required
                />
              </Box>

              <Box mt={4} display="flex" justifyContent="flex-start">
                <Button
                  variant="contained"
                  type="submit"
                  size="large"
                  sx={{
                    px: 4,
                    py: 1,
                    borderRadius: 1,
                    textTransform: "none",
                    fontWeight: 700,
                    bgcolor: "#FFC857",
                    "&:hover": {
                      bgcolor: "#E6B54E"
                    }
                  }}
                >
                  Submit
                </Button>
              </Box>
            </form>
          </CardContent>
        </Box>

        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          handleClose={() =>
            this.setState({
              toast: { ...this.state.toast, open: false }
            })
          }
        />
      </Container>
    );
  }
}

export default redux(AddSupplierScreen);
